import React from 'react';
import type { RevenueSnapshot } from '../../types/dashboard';

type RevenueCardProps = {
  revenue: RevenueSnapshot;
  onViewDetails: () => void;
};

export function RevenueCard({ revenue, onViewDetails }: RevenueCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'INR',
      maximumFractionDigits: 0
    }).format(amount);
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm px-4 py-3 border border-gray-100">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-medium text-gray-700">This Month:</span>
          <span className="text-sm">
            <span className="font-semibold text-green-600">
              {formatCurrency(revenue.thisMonth.received)}
            </span>
            <span className="text-gray-500"> received</span>
          </span>
          <span className="text-gray-300">•</span>
          <span className="text-sm">
            <span className="font-semibold text-amber-600">
              {formatCurrency(revenue.thisMonth.pending)}
            </span>
            <span className="text-gray-500"> pending</span>
          </span>
        </div>
        <button
          onClick={onViewDetails}
          className="text-sm font-medium text-[#5B8E87] hover:text-[#4A7670] transition-colors whitespace-nowrap"
        >
          View details →
        </button>
      </div>
    </div>
  );
}
